import styled from 'styled-components';

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #0e0e0e;
`;

export const SliderContent = styled.div`
    width: 100%;
    height: 100%;
    overflow: auto;
    // padding: 20px;
    display: ${props => (props.display ? props.display : 'flex !important')};
    flex-wrap: wrap;
    align-content: flex-start;
    outline: none !important;
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/ChannelDisplay/style.js